import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronRight"><Path fillRule="evenodd" clipRule="evenodd" d="M9.00011 2.93945L18.0608 12.0001L9.00011 21.0608L7.93945 20.0001L15.9395 12.0001L7.93945 4.00011L9.00011 2.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRight;
